import APIService from "./APIService";

export default {
    async getConfig() {
        const res = await APIService.apiCall().get('company-indger-configs');
        return res.data;
    },
    async update(postData) {
        const res = await APIService.apiCall().put('company-indger-configs/update', postData);
        return res.data;
    },
};
